import styled from 'styled-components';

const StyledInputArrowContainer = styled.div`
	display: flex;
	gap: 10px;
	flex-direction: row;
	justify-content: stretch;

	& > * {
		border-radius: 3px;
	}
`;

const StyledTextContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	span {
		font-family: 'GT Walsheim Pro';
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledSelectorContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledInput = styled.input`
	display: block;
	width: 60px;
	height: 20px;
	padding: 4px;
	border-width: 0;
	outline: none;

	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	text-align: center;
`;

const StyledArrow = styled.i<{ $direction: 'left' | 'right' }>`
	display: block;
	position: relative;
	width: 20px;
	height: 20px;
	background-color: rgba(50, 50, 50, 1);
	cursor: pointer;

	&::after {
		content: '';
		position: absolute;
		inset: 6px;
		border: solid white;
		border-width: 0 3px 3px 0;
		transform: rotate(
			${({ $direction }) => ($direction === 'left' ? '135deg' : '-45deg')}
		);
	}
`;

export {
	StyledArrow,
	StyledInput,
	StyledInputArrowContainer,
	StyledSelectorContainer,
	StyledTextContainer,
};
